import ExactSearchContent from '../components/ExactSearch/ExactSearch.js';

const ExactSearchPage = () => {
  return <ExactSearchContent />;
};

export default ExactSearchPage;
